import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import AdminNavbar from "../../Components/AdminNavbar/AdminNavbar";

const ViewProductInfo = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetch(`https://backend-server-nine-opal.vercel.app/contents/${id}`, {
      // credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setProduct(data))
      .catch((err) => console.error("Error loading product:", err));
  }, [id]);

  if (!product) return <div className="text-center mt-10">Loading...</div>;

  return (
    <div>
      <AdminNavbar />
      <div className="container mx-auto">
        <div className="flex justify-between items-center mt-4">
          <div className="text-sm px-4 breadcrumbs">
            <ul>
              <li>
                <Link to="/dashboard">
                  <a className="flex items-center"> Dashboard</a>
                </Link>
              </li>
              <li>View Product Info</li>
            </ul>
          </div>
          <Link to={`/dashboard/editProduct/${id}`}>
            <button className="btn btn-accent">Edit Product Info</button>
          </Link>
        </div>
        <div className=" mx-auto p-6 bg-white shadow-md rounded-xl mt-4">
          <h1 className="text-3xl font-bold text-center mb-6 text-gray-800">
            {product.Product_name}
          </h1>

          {/* Basic Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 justify-items-start">
            <p>
              <strong>Pack Size:</strong> {product.Pack_Size}
            </p>
            <p>
              <strong>Category:</strong> {product.product_Category}
            </p>
            <p>
              <strong>Net Wt:</strong> {product.Net_Wt} Kg
            </p>
            <p>
              <strong>Gross Wt:</strong> {product.Gross_Wt} Kg
            </p>
            <p>
              <strong>Carton Dimension:</strong> {product.Carton_Dim}
            </p>
            <p>
              <strong>Added By:</strong> {product.user_name} (
              {product.user_email})
            </p>
          </div>

          {/* Rich Text Description */}
          {product.richTexts && product.richTexts.length > 0 && (
            <div className="mt-8 text-left border-2 p-6 rounded-lg bg-gray-50">
              <h2 className="text-2xl font-semibold mb-4 text-left">
                Product Details
              </h2>
              <div className="space-y-8">
                {product.richTexts.map((section, idx) => (
                  <div key={idx} className="prose prose-neutral max-w-full">
                    <h3 className="text-xl font-semibold">{section.title}</h3>
                    <div
                      dangerouslySetInnerHTML={{ __html: section.content }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Product Images */}
          <div className="mt-8 border-2 p-6 rounded-lg bg-gray-50">
            <h2 className="text-2xl font-semibold mb-4">Product Images</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {product.Product_Details_Photo && (
                <img
                  src={product.Product_Details_Photo}
                  alt="Details"
                  loading="lazy"
                  className="w-full rounded shadow"
                />
              )}
              {[product.photo1, product.photo2, product.photo3, product.photo4]
                .filter(Boolean)
                .map((url, i) => (
                  <img
                    key={i}
                    loading="lazy"
                    src={url}
                    alt={`Product ${i + 1}`}
                    className="w-full rounded shadow"
                  />
                ))}
            </div>
          </div>

          {/* Back Button */}
          <div className="mt-10 text-center">
            <Link to="/dashboard">
              <button className="px-6 py-2 bg-gray-700 text-white rounded hover:bg-gray-900">
                ⬅ Back to Dashboard
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewProductInfo;
